import React from 'react';
import './trustBadges.css';

const TrustBadges = () => {
  const badges = [
    {
      icon: 'fas fa-shield-alt',
      title: '100% Satisfaction',
      subtitle: 'Guaranteed',
    },
    {
      icon: 'fas fa-leaf',
      title: 'Eco-Friendly',
      subtitle: 'Products',
    },
    {
      icon: 'fas fa-certificate',
      title: 'Fully Insured',
      subtitle: '& Bonded',
    },
    {
      icon: 'fas fa-clock',
      title: 'On-Time',
      subtitle: 'Service',
    },
  ];

  return (
    <div className="trust-badges" data-aos="fade-up" data-aos-duration="800">
      <div className="badges-container">
        {badges.map((badge, index) => (
          <div 
            key={index} 
            className="badge-item"
            data-aos="zoom-in"
            data-aos-delay={index * 100}
            data-aos-duration="600"
          >
            <div className="badge-icon">
              <i className={badge.icon}></i>
            </div>
            <div className="badge-text">
              <h4>{badge.title}</h4>
              <p>{badge.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustBadges;
